export const SectorHtmlIdBySectorCode = {
    C: 'containership',
    D: "dry-bulk",
    T: 'oil-tanker',
    LNG: 'lng-carrier',
    PCTC: 'car-truck-carrier',
    CH: 'chemical-tanker',
    MPP: 'multi-purpose',
    LPG: 'lpg-carrier'
}

export const VesselCharactericsSelectOptionsBySectorName = {

    DryBulk: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        Gear: ["Geared", "Gearless"],
        Hatch: ["Standard Bulker", "Semi-Open Hatch (Jib)", "Fully-Open Hatch (Jib)", "Fully-Open Hatch (Gantry)"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"],
        FuelSystem: ["Conventional", "LNG Dual-Fuel", "Methanol Dual-Fuel", "Ammonia Dual-Fuel"]
    },

    OilTanker: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        Tank: ["Crude", "Product"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"],
        PumpRoom: ["Yes", "No"],
        FuelSystem: ["Conventional", "LNG Dual-Fuel", "Methanol Dual-Fuel", "Ammonia Dual-Fuel"]
    },

    Containership: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        Gear: ["Geared", "Gearless"],
        Eco: ["Eco", "Non-Eco"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"],
        FuelSystem: ["Conventional", "LNG Dual-Fuel", "Methanol Dual-Fuel", "Ammonia Dual-Fuel"]
    },

    ChemicalTanker: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        Tank: ["Chemical", "Chemical Parcel"],
        ImoClassCoating: ["IMO III Epoxy", "IMO II/III Epoxy", "IMO II Epoxy", "IMO II/III Zinc", "IMO II Zinc", "IMO II/III MarineLine", "IMO II MarineLine", "IMO II/III InterLine", "IMO II InterLine", "IMO II/III Stainless Steel", "IMO II Stainless Steel", "IMO I/II Stainless Steel", "IMO I/II/III Stainless Steel" ]
    },

    LngCarrier: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        PropulsionSystem: ["Standard Diesel Engine", "Steam Turbine", "Ultra Steam Turbine", "Reheat Steam Turbine", "STaGE", "DFDE", "TFDE", "MEGI", "MEGA", "X-DF"],
        CargoContainment: ["MOSS", "Membrane"]
    },

    LpgCarrier: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        TankType: ["Fully-Pressurised", "Semi-Refrigerated", "Ethylene Carrier", "Fully-Refrigerated"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"],
        AmmoniaCarrier: ["Yes", "No"],
        FuelSystem: ["Conventional", "LPG Dual-Fuel", "Ammonia Dual-Fuel"]
    },

    CarTruckCarrier: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        HoistableDecks: ["0", "1", "2", "3", "4", "5", "6"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"],
        FuelSystem: ["Conventional", "LNG Dual-Fuel", "Methanol Dual-Fuel", "Ammonia Dual-Fuel"]
    },

    MultiPurpose: {
        CountryOfBuild: ["China", "Japan", "South Korea", "Other Asia", "Other"],
        YardTier: ["Tier 1", "Tier 2"],
        IceClass: ["None", "1A", "1B And Below"],
        Gear: ["Gearless or Low Level Gear", "Geared", "Geared Heavy Lift"],
        ScrubberFitted: ["None", "Open-Loop", "Hybrid"]
    }
}


export const SectorCodeBySectorName = {
    Containership: 'C',
    DryBulk: 'D',
    OilTanker: 'T',
    LngCarrier: 'LNG',
    CarTruckCarrier: 'PCTC',
    ChemicalTanker: 'CH',
    MultiPurpose: 'MPP',
    LpgCarrier: 'LPG'
}

export const SizeLabelAndUnitBySectorCode = {
    D: { label: "Size", unit: "Dwt" },
    T: { label: "Size", unit: "Dwt" },
    C: { label: "Size", unit: "TEU" },
    CH: { label: "Capacity", unit: "Dwt" },
    LNG: { label: "Size", unit: "CuM" },
    LPG: { label: "Capacity", unit: "CuM" },
    PCTC: { label: "Size", unit: "CEU" },
    MPP: { label: "Capacity", unit: "Dwt" }
}

export const getVesselCharacteristicLabelName = (sectorCode: string, fieldId: string) => {
    if (fieldId === VesselCharacteristicFieldNameByFieldId.vesselName) {
        return "Vessel ID";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.size) {
        if (sectorCode === SectorCodeBySectorName.DryBulk) {
            return "Size (Dwt)";
        }
        if (sectorCode === SectorCodeBySectorName.OilTanker) {
            return "Size (Dwt)";
        }
        if (sectorCode === SectorCodeBySectorName.Containership) {
            return "Size (TEU)";
        }
        if (sectorCode === SectorCodeBySectorName.ChemicalTanker) {
            return "Capacity (Dwt)";
        }
        if (sectorCode === SectorCodeBySectorName.LngCarrier) {
            return "Size (CuM)";
        }
        if (sectorCode === SectorCodeBySectorName.LpgCarrier) {
            return "Capacity (CuM)";
        }
        if (sectorCode === SectorCodeBySectorName.CarTruckCarrier) {
            return "Size (CEU)";
        }
        if (sectorCode === SectorCodeBySectorName.MultiPurpose) {
            return "Capacity (Dwt)";
        }
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.yearOfDelivery) {
        return "Year of Delivery";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.iceClass) {
        return "Ice Class";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.countryOfBuild) {
        return "Country of Build";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.yardTier) {
        return "Yard Tier";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.saveVessel) {
        return "Save Vessel";
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.gear) {
        return "Gear"; // Dry Bulk Carrier and Containership
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.hatch) {
        return "Hatch"; // Dry Bulk Carrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.efficiency) {
        if (sectorCode === SectorCodeBySectorName.DryBulk) {
            return "Efficiency";
        }
        if (sectorCode === SectorCodeBySectorName.OilTanker) {
            return "Efficiency";
        }
        if (sectorCode === SectorCodeBySectorName.Containership) {
            return "Efficiency (if Non-Eco)";
        }
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.tank) {  // imoClassCoating - tanktype - tank
        if (sectorCode === SectorCodeBySectorName.OilTanker) {
            return "Tank";
        }
        if (sectorCode === SectorCodeBySectorName.LpgCarrier) {
            return "Tank Type";
        }
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.imoClassAndCoating) {
         return "IMO Class and Coating"; // Chemical Tanker
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.dwtCapacity) {
        return "Dwt Capacity"; // Containership
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.reeferPlugs) {
        return "Reefer Plugs"; // Containership
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.homogeneousIntake) {
        return "Homogeneous Intake at 14T"; // Containership
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.eco) {
        return "Eco"; // Containership
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.fuelSystem) {
        return "Fuel System"; // Containership, DryBulk, OilTanker, LPGCarrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.cargoContainment) {
        return "Cargo Containment"; // LNG Carrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.hoistableDecks) {
        return "Hoistable Decks"; // Car/Truck Carrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.quarterRampCapacity) {
        return "Quarter Ramp Capacity"; // Car/Truck Carrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.dynamicPositioning) {        
            return "Dynamic Positioning"; // PSV / AHTS       

    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.fireFightingCapability) {
        return "Fire-Fighting Capability"; // PSV / AHTS
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.propulsionSystem) {
        return "Propulsion System"; // PSV / AHTS /LNG Carrier
    }

    if (fieldId === VesselCharacteristicFieldNameByFieldId.scrubberFitted) {
        return "Scrubber-Fitted"; // DB, OT, C
    }
    if (fieldId === VesselCharacteristicFieldNameByFieldId.pumpRoom) {
        return "Pump Room"; //OT
    }
    if (fieldId === VesselCharacteristicFieldNameByFieldId.referenceImoNumber) {
        return "Reference IMO Number"; // Dry Bulk Carrier
    }
    if (fieldId === VesselCharacteristicFieldNameByFieldId.ammoniaCarrier) {
        return "Ammonia Carrier"; // Dry Bulk Carrier
    }
    if(fieldId === VesselCharacteristicFieldNameByFieldId.draught) {
        return "Draught (m)";
    }
    if(fieldId === VesselCharacteristicFieldNameByFieldId.breadth) {
        return "Beam (m)";
    }
    if(fieldId === VesselCharacteristicFieldNameByFieldId.lengthOverallLoa) {
        return "Length Overall (m)";
    }
    if(fieldId === VesselCharacteristicFieldNameByFieldId.grossTonnage) {
        return "Gross Tonnage";
    }
    if(fieldId === VesselCharacteristicFieldNameByFieldId.flag) {
        return "Flag";
    }
}

export const VesselCharacteristicFieldNameByFieldId = {
    // Common
    vesselName: "vesselName",
    size: "size",
    yearOfDelivery: "yearOfDelivery",
    iceClass: "iceClass",
    countryOfBuild: "countryOfBuild",
    yardTier: "yardTier",
    saveVessel: "isSaved",

    gear: "gear", //Gear in DB //Dry Bulk Carrier // Containership // MPP
    hatch: "hatch", //Hatch in DB //Dry Bulk Carrier
    // hull: "hull", //Hull in DB //Dry Bulk Carrier
    efficiency: "efficiency", //Efficiency in DB //Dry Bulk Carrier // Oil Tanker // Containership
    draught: "draught", //Draught all
    // Tank, Tank Type
    tank: "tank", //Tank in DB // Oil Tanker // Chemical Tanker // LPG Carrier   

    imoClassAndCoating: "imoClassAndCoating", // ImoClassAndCoating in DB // Chemical Tanker

    dwtCapacity: "dwtCapacity", // DwtCapacity in DB // Containership
    reeferPlugs: "reeferPlugs", // ReeferPlugs in DB // Containership
    homogeneousIntake: "homogeneousIntake", // HomogeneousIntake in DB // Containership
    eco: "eco", // Eco in DB  // Containership    

    //Propusion System
    propulsionSystem: "propulsionSystem", // old Engine changed to Propulsion System in DB // LNG Carrier // PSV // AHTS  **************

    cargoContainment: "cargoContainment", // CargoContainment in DB // LNG Carrier

    hoistableDecks: "hoistableDecks", // HoistableDecks in DB // Car/Truck Carrier
    quarterRampCapacity: "quarterRampCapacity", // QRCapacity in DB // Car/Truck Carrier

    dynamicPositioning: "dynamicPositioning", // DynamicPositioning in DB // PSV // AHTS
    fireFightingCapability: "fireFightingCapability", // DireFightingCapability in DB // PSV // AHTS

    // DB, C, OT, MPP, PCTC, CH
    scrubberFitted: "scrubberFitted",

    //OT
    pumpRoom: "pumpRoom",
    fuelSystem: "fuelSystem",//PCTC
    referenceImoNumber: "referenceImoNumber",

    ammoniaCarrier: "ammoniaCarrier", //AmmoniaCarrier in DB // LPG Carrier  

    breadth: "breadth", //breadth all
    lengthOverallLoa: "lengthOverallLoa", //lengthOverallLoa all
    grossTonnage: "grossTonnage", //grossTonnage all
    flag: "flag", //flag all    
}

const maxYear = new Date().getFullYear(); //+ 6;
export const VesselCharacteristicInfoMessageBySectorName = {

    Containership: {
        size: "<div style='text-align:left'>Twenty foot equivalent units (which is equivalent to one 20 foot shipping container), the standard conversion used to quantify the container capacity of a ship.<br/><br/><li>Between 500 and 24500 TEU.</li></div>",
        sizeMsi: "<div style='text-align:left'>Twenty foot equivalent units (which is equivalent to one 20 foot shipping container), the standard conversion used to quantify the container capacity of a ship.<br/><br/><li>Between 0 and 24500 TEU.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None - </strong>No ice class classification.</li><li><strong>1A - </strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below - </strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan - </strong>Shipyard located in Japan.</li><li><strong>South Korea - </strong>Shipyard located in South Korea.</li><li><strong>China - </strong>Shipyard located in China.</li><li><strong>Other Asia - </strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other - </strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1 - </strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2 - </strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        gear: "<div style='text-align:left'><li><strong>Geared - </strong>A vessel equipped with its own crane(s).</li><li><strong>Gearless - </strong>A vessel which is not equipped with its own crane(s).</li></div>",
        dwtCapacity: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc.</div>",
        reeferPlugs: "<div style='text-align:left'>Number of reefer plugs.</div>",
        homogeneousIntake: "<div style='text-align:left'>A theoretical figure reflecting the maximum number of homogeneously loaded boxes each with a gross weight of 14 tonnes.</div>",
        eco: "<div style='text-align:left'><li><strong>Eco - </strong>A containership contracted at a shipyard from 2010 onwards.</li><li><strong>Non-Eco - </strong>A containership contracted at a shipyard before 2010.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        fuelSystem: "<div style='text-align:left'><li><strong>Conventional - </strong>Conventional</li><li><strong>LNG Dual-Fuel - </strong>LNG Dual-Fuel</li><li><strong>Methanol Dual-Fuel - </strong>Methanol Dual-Fuel</li><li><strong>Ammonia Dual-Fuel - </strong>Ammonia Dual-Fuel</li></div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel with vertical cell-guides designed to carry container boxes.",
        referenceImoNumber: "FMV does not require an IMO number- this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    DryBulk: {
        size: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 25000 and 410000 tonnes.</li></div>",
        sizeMsi: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 0 and 410000 tonnes.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None&nbsp;-&nbsp;</strong>No ice class classification.</li><li><strong>1A&nbsp;-&nbsp;</strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below&nbsp;-&nbsp;</strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan&nbsp;-&nbsp;</strong>Shipyard located in Japan.</li><li><strong>South Korea&nbsp;-&nbsp;</strong>Shipyard located in South Korea.</li><li><strong>China&nbsp;-&nbsp;</strong>Shipyard located in China.</li><li><strong>Other Asia&nbsp;-&nbsp;</strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other&nbsp;-&nbsp;</strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1&nbsp;-&nbsp;</strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2&nbsp;-&nbsp;</strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        gear: "<div style='text-align:left'><li><strong>Geared&nbsp;-&nbsp;</strong>A vessel equipped with its own crane(s).</li><li><strong>Gearless&nbsp;-&nbsp;</strong>A vessel which is not equipped with its own crane(s).</li></div>",
        hatch: "<div style='text-align:left'>The opening in the deck of a vessel through which cargo is loaded into or discharged from the hold.<br/><br/><li><strong>Standard Bulker&nbsp;-&nbsp;</strong>Bulk carrier with a hatch width that is less than 80% of the ship’s beam.</li><li><strong>Semi-Open Hatch (Jib)&nbsp;-&nbsp;</strong>Double-hulled bulk carrier or general cargo vessel equipped with jib cranes and box-shaped holds where the hatch width is equal to 80% or greater than the ship’s beam.</li><li><strong>Fully-Open Hatch (Jib)&nbsp;-&nbsp;</strong>As for Semi-Open Hatch (Jib), and where the hatch opening extends for the full width of the cargo space.</li><li><strong>Fully-Open Hatch (Gantry)&nbsp;-&nbsp;</strong>As for Fully-Open Hatch (Jib) but equipped with two travelling gantry cranes, rather than jib cranes.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        fuelSystem: "<div style='text-align:left'><li><strong>Conventional - </strong>Conventional</li><li><strong>LNG Dual-Fuel - </strong>LNG Dual-Fuel</li><li><strong>Methanol Dual-Fuel - </strong>Methanol Dual-Fuel</li><li><strong>Ammonia Dual-Fuel - </strong>Ammonia Dual-Fuel</li></div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel with a single deck designed to carry homogeneous dry bulk cargo such as iron ore, coal and grain.",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    OilTanker: {
        size: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li><strong>Crude - </strong>Between 25000 and 350000 tonnes.</li><li><strong>Product - </strong>Between 25000 and 125000 tonnes.</li></div>",
        sizeMsi: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li><strong>Crude - </strong>Between 0 and 350000 tonnes.</li><li><strong>Product - </strong>Between 0 and 125000 tonnes.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None - </strong>No ice class classification.</li><li><strong>1A - </strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below - </strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan - </strong>Shipyard located in Japan.</li><li><strong>South Korea - </strong>Shipyard located in South Korea.</li><li><strong>China - </strong>Shipyard located in China.</li><li><strong>Other Asia - </strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other - </strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1 - </strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2 - </strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        tank: "<div style='text-align:left'><li><strong>Crude - </strong>Crude tankers are specifically used to transport crude oil from the excavation site to the crude oil refining industrial plant.</li><li><strong>Product - </strong>Product tankers are often built with many segregated cargo tanks and are used to transport refined oil products.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        fuelSystem: "<div style='text-align:left'><li><strong>Conventional - </strong>Conventional</li><li><strong>LNG Dual-Fuel - </strong>LNG Dual-Fuel</li><li><strong>Methanol Dual-Fuel - </strong>Methanol Dual-Fuel</li><li><strong>Ammonia Dual-Fuel - </strong>Ammonia Dual-Fuel</li></div>",
        pumpRoom: "<div style='text-align:left'>A pump room houses the pumps for cargo loading and discharge in a separate location away from the cargo tanks.<br/><br/><li><strong>Yes - </strong>Vessel has a pump room</li><li><strong>No - </strong>Vessel does not have a pump room but in-tank cargo pumps</li></div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel fitted with tanks for the bulk transport of oil (crude and/or refined oil products).",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    ChemicalTanker: {
        size: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 3000 and 52000 tonnes.</li></div>",
        sizeMsi: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 0 and 52000 tonnes.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None - </strong>No ice class classification.</li><li><strong>1A - </strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below - </strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan - </strong>Shipyard located in Japan.</li><li><strong>South Korea - </strong>Shipyard located in South Korea.</li><li><strong>China - </strong>Shipyard located in China.</li><li><strong>Other Asia - </strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other - </strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1 - </strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2 - </strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        tank: "<div style='text-align:left'><li><strong>Chemical - </strong>Standard Chemical Tanker.</li><li><strong>Chemical Parcel - </strong>Chemical Tanker super segregated or with a high level of segregation.</li></div>",
        imoClassAndCoating: "<div style='text-align:left'>The categorisation of a chemical tanker (design, construction, equipment and operational requirements) carrying substances identified in chapter 17 of the IBC Code.</div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel fitted with tanks for the bulk transport of liquid chemicals.",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    LngCarrier: {
        size: "<div style='text-align:left'>The capacity of liquid that the vessel can carry. Measured in cubic metres.<br/><br/><li>Between 120000 and 300000 CuM.</li></div>",
        sizeMsi: "<div style='text-align:left'>The capacity of liquid that the vessel can carry. Measured in cubic metres.<br/><br/><li>Between 0 and 300000 CuM.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None - </strong>No ice class classification.</li><li><strong>1A - </strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below - </strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan - </strong>Shipyard located in Japan.</li><li><strong>South Korea - </strong>Shipyard located in South Korea.</li><li><strong>China - </strong>Shipyard located in China.</li><li><strong>Other Asia - </strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other - </strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1 - </strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2 - </strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        propulsionSystem: "<div style='text-align:left'><li><strong>Steam Turbine / Reheat Steam Turbine / Ultra Steam Turbine - </strong>Steam turbine propelled vessel.</li><li><strong>Steam Turbine and Gas Engine (STaGE) - </strong>Hybrid system consisting of a Gas Engine and a Steam turbine that also utilises the waste heat from the engine.</li><li><strong>Dual-fuel Diesel Electric (DFDE) / Tri-fuel Diesel Electric (TFDE) - </strong>Vessels fitted with several medium speed gas/diesel engines, which drive electrical generators that supply with electricity to all the ship’s systems, including propulsion and thrusters’ motors.</li><li><strong>MEGI - </strong>Vessels fitted with two-stroke low-speed engines that uses the diesel cycle when running on LNG with the gas being injected at high pressure. The MEGI engine was developed by MAN Marine Engines and Systems.</li><li><strong>X-DF / MEGA- </strong>Vessels fitted with two-stroke low-speed engines that uses the Otto cycle when running on LNG, in which a compressed lean air-gas mixture is injected at low pressure. The X-DF engine was developed by WinGD while the MEGA was developed by MAN Marine Engines and Systems.</li></div>",
        cargoContainment: "<div style='text-align:left'><li><strong>MOSS - </strong>This tank is of the Kvaerner Moss design.</li><li><strong>Membrane - </strong>Other tank types.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel designed to carry liquefied natural gas at -160°C.",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    LpgCarrier: {
        size: "<div style='text-align:left'>The capacity of liquid that the vessel can carry. Measured in cubic metres.<br/><br/><li><strong>Fully-Pressuried - </strong>between 2500 and 12000 CuM.</li><li><strong>Semi-Refrigerated - </strong>between 2500 and 25000 CuM.</li><li><strong>Ethylene Carrier - </strong>between 2500 and 25000 CuM.</li><li><strong>Fully-Refrigerated - </strong>between 30000 and 100000 CuM.</li></div>",
        sizeMsi: "<div style='text-align:left'>The capacity of liquid that the vessel can carry. Measured in cubic metres.<br/><br/><li><strong>Fully-Pressuried - </strong>between 0 and 12000 CuM.</li><li><strong>Semi-Refrigerated - </strong>between 0 and 25000 CuM.</li><li><strong>Ethylene Carrier - </strong>between 0 and 25000 CuM.</li><li><strong>Fully-Refrigerated - </strong>between 0 and 100000 CuM.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None - </strong>No ice class classification.</li><li><strong>1A - </strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below - </strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan - </strong>Shipyard located in Japan.</li><li><strong>South Korea - </strong>Shipyard located in South Korea.</li><li><strong>China - </strong>Shipyard located in China.</li><li><strong>Other Asia - </strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other - </strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1 - </strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2 - </strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        tank: "<div style='text-align:left'><li><strong>Fully-Pressurised - </strong>Tankers which carry products at ambient temperatures in cylindrical or spherical steel pressure vessel designed to withstand pressures up to 20 bar.</li><li><strong>Semi-Refrigerated - </strong>Tankers which are fitted with a refrigeration plant that provides a fully refrigerated ability while possessing a high design pressure for the cargo tanks below that required for fully pressurised carriage.</li><li><strong>Ethylene Carrier - </strong>A semi-pressurised/refrigerated tanker which can carry most liquified gas cargoes (except LNG) and ethylene, fully refrigerated at its atmospheric pressure boiling point of -104°C.</li><li><strong>Fully-Refrigerated - </strong>Tankers which are built to carry liquefied gases at low temperature and atmospheric pressure between terminals equipped with fully refrigerated storage tanks. They can carry cargoes at temperatures as low as -48°C.</li><div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel designed to carry liquid petroleum gas or liquid chemical gases.",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        fuelSystem: "<div style='text-align:left'><li><strong>Conventional - </strong>Conventional</li><li><strong>LPG Dual-Fuel - </strong>LPG Dual-Fuel</li><li><strong>Ammonia Dual-Fuel - </strong>Ammonia Dual-Fuel</li></div>",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    },

    CarTruckCarrier: {
        size: "<div style='text-align:left'>The cargo capacity of a pure car/truck carrier (PCTC) is measured in car equivalent units (CEU), equivalent to 10 cubic metres.<br/><br/><li>Between 500 and 12500 CEU.</li></div>",
        sizeMsi: "<div style='text-align:left'>The cargo capacity of a pure car/truck carrier (PCTC) is measured in car equivalent units (CEU), equivalent to 10 cubic metres.<br/><br/><li>Between 0 and 12500 CEU.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None&nbsp;-&nbsp;</strong>No ice class classification.</li><li><strong>1A&nbsp;-&nbsp;</strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below&nbsp;-&nbsp;</strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan&nbsp;-&nbsp;</strong>Shipyard located in Japan.</li><li><strong>South Korea&nbsp;-&nbsp;</strong>Shipyard located in South Korea.</li><li><strong>China&nbsp;-&nbsp;</strong>Shipyard located in China.</li><li><strong>Other Asia&nbsp;-&nbsp;</strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other&nbsp;-&nbsp;</strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1&nbsp;-&nbsp;</strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2&nbsp;-&nbsp;</strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        hoistableDecks: "<div style='text-align:left'>Number of moveable car decks which are stowed under the deckhead and lowered on wires into their operational postion.</div>",
        quarterRampCapacity: "<div style='text-align:left'>Maximum weight in tonnes a ramp can take at anytime.<br/><br/><li>Between 5 and 400 tonnes.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel with multiple internal decks designed to carry vehicles and heavy rolling equipment, primarily loaded by means of a stern quarter ramp.",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        fuelSystem: "<div style='text-align:left'><li><strong>Conventional - </strong>Conventional</li><li><strong>LNG Dual-Fuel - </strong>LNG Dual-Fuel</li><li><strong>Methanol Dual-Fuel - </strong>Methanol Dual-Fuel</li><li><strong>Ammonia Dual-Fuel - </strong>Ammonia Dual-Fuel</li></div>",
        referenceImoNumber: "FMV does not require an IMO number– this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
        
    },

    MultiPurpose: {
        size: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 7000 and 37500 tonnes.</li></div>",
        sizeMsi: "<div style='text-align:left'>The weight in tonnes of the vessel's maximum cargo capacity, including cargo, stores and bunkers, etc. <br/><br/><li>Between 0 and 37500 tonnes.</li></div>",
        yearOfDelivery: "<div style='text-align:left'>The year ship was delivered by the shipyard to the original owner.<br/><br/><li>Between 1980 and " + maxYear + ".</li></div>",
        iceClass: "<div style='text-align:left'>Notation of a ship designed with a strengthened hull to enable them to navigate through sea ice.<br/><br/><li><strong>None&nbsp;-&nbsp;</strong>No ice class classification.</li><li><strong>1A&nbsp;-&nbsp;</strong>Capable of navigating in difficult ice conditions with the assistance of icebreakers when necessary. Ships with an ice class of 1A are certified to transit ice of 0.8m thickness. Based on Finnish-Swedish Ice Class Rules (or equivalent).</li><li><strong>1B And Below&nbsp;-&nbsp;</strong>A vessel with ice class classification that is not Ice Class 1A or above (or equivalent).</li></div>",
        countryOfBuild: "<div style='text-align:left'>Country where the vessel was constructed.<br/><br/><li><strong>Japan&nbsp;-&nbsp;</strong>Shipyard located in Japan.</li><li><strong>South Korea&nbsp;-&nbsp;</strong>Shipyard located in South Korea.</li><li><strong>China&nbsp;-&nbsp;</strong>Shipyard located in China.</li><li><strong>Other Asia&nbsp;-&nbsp;</strong>Shipyards located in Asian countries excluding Japan, China and South Korea.</li><li><strong>Other&nbsp;-&nbsp;</strong>Shipyards not located in Asia.</li></div>",
        yardTier: "<div style='text-align:left'><li><strong>Tier 1&nbsp;-&nbsp;</strong>A shipyard with a proven track record of building both commodity (bulkers, oil tankers and/or containerships) and specialised vessels for predominately an export market.</li><li><strong>Tier 2&nbsp;-&nbsp;</strong>A shipyard building predominately small (LOA less than 300m) commodity vessels (bulkers, oil tankers and/or containerships).</li></div>",
        gear: "<div style='text-align:left'><li><strong>Geared&nbsp;-&nbsp;</strong>A vessel equipped with its own cranes and where the largest gear equipment has a safe working load that is below 120 T.</li><li><strong>Gearless or Low Level Gear&nbsp;-&nbsp;</strong>A vessel which is not equipped with its own cranes or has gear equipment with largest safe working load that is lower than 30 T.</li><li><strong>Geared Heavy Lift&nbsp;-&nbsp;</strong>A vessel equipped with its own cranes and where the largest gear equipment has a safe working load that is between 120 T and 300 T.</li></div>",
        draught: "<div style='text-align:left'>Design draught (scantling draught) in fully loaded condition (salt water)</div>",
        scrubberFitted: "<div style='text-align:left'><li><strong>Open Loop - </strong>Vessel is fitted with an Open Loop Scrubber</li><li><strong>Hybrid - </strong>Vessel is fitted with a Hybrid Scrubber</li></div>",
        saveVessel: "<div style='text-align:left'>Save vessel so that it appear in your list under 'My Saved Vessels'.</div>",
        vesselInfo: "A vessel designed to carry heterogeneous general, bulk and/or containerised cargo.<br/><br />Excludes heavy lift MPP vessels with any single crane SWL over 300T.",
        referenceImoNumber: "FMV does not require an IMO number- this makes it possible to extract data for theoretical ships, for instance comparing historical and forecast data for different benchmark vessels. However, if the ‘Reference IMO Number’ input is completed, then additional information can be provided through FMV, such as historical emissions estimates for the vessel with this IMO number. Where completed, please make sure this IMO number corresponds to your vessel.",
        breadth: "<div style='text-align:left'>Breadth at the widest point of the ship (mid-section)</div>",
        lengthOverallLoa: "<div style='text-align:left'>Total length of the vessel measured from the foremost point of the bow to the aftermost point of the stern</div>",
        grossTonnage: "<div style='text-align:left'>A measure of a ship's overall internal volume, used to determine various regulations, such as manning requirements, safety rules, registration fees, and port dues.</div>",
        flag: "<div style='text-align:left'>The country under whose laws a vessel is registered</div>",
    }
}


export const SectorUIFields = (isMSI: boolean) => [
    {
        sectorCode: "D",
        name: "Dry Bulk",
        htmlId: "dry-bulk",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.D.label} (${SizeLabelAndUnitBySectorCode.D.unit})`,
                    name: "size",
                    startHtmlId: "d-min-size",
                    minValue: isMSI ? 0 : 25000,
                    endHtmlId: "d-max-size",
                    maxValue: 410000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.DryBulk.sizeMsi : VesselCharacteristicInfoMessageBySectorName.DryBulk.size
                }

            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "d-min-year",
                    minValue: 1980,
                    endHtmlId: "d-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "d-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "d-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.countryOfBuild
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "d-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "d-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Gear",
                    name: "gear",
                    htmlId: "d-gear",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.Gear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.gear
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Hatch",
                    name: "hatch",
                    htmlId: "d-hatch",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.Hatch,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.hatch
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "d-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.scrubberFitted
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Fuel System",
                    name: "fuelSystem",
                    htmlId: "d-fuel-system",
                    options: VesselCharactericsSelectOptionsBySectorName.DryBulk.FuelSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.fuelSystem
                }
            },      
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "d-min-draught",
                    endHtmlId: "d-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.draught
                }
            },      
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }

        ]
    },
    {
        sectorCode: "T",
        name: "Oil Tanker",
        htmlId: "oil-tanker",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.T.label} (${SizeLabelAndUnitBySectorCode.T.unit})`,
                    name: "size",
                    startHtmlId: "t-min-size",
                    minValue: isMSI ? 0 : 25000,
                    endHtmlId: "t-max-size",
                    maxValue: 350000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.OilTanker.sizeMsi : VesselCharacteristicInfoMessageBySectorName.OilTanker.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "t-min-year",
                    minValue: 1980,
                    endHtmlId: "t-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "t-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "t-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.countryOfBuild
                }
            },            
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "t-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "t-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Tank",
                    name: "tank",
                    htmlId: "t-tank",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.Tank,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.tank
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Pump Room",
                    name: "pumpRoom",
                    htmlId: "t-pump-room",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.PumpRoom,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.pumpRoom
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "t-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.scrubberFitted
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Fuel System",
                    name: "fuelSystem",
                    htmlId: "t-fuel-system",
                    options: VesselCharactericsSelectOptionsBySectorName.OilTanker.FuelSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.fuelSystem
                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "t-min-draught",                    
                    endHtmlId: "t-max-draught",                    
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.OilTanker.draught
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }


        ]
    },
    {
        sectorCode: "C",
        name: "Containership",
        htmlId: "containership",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.C.label} (${SizeLabelAndUnitBySectorCode.C.unit})`,
                    name: "size",
                    startHtmlId: "c-min-size",
                    minValue: isMSI ? 0 : 500,
                    endHtmlId: "c-max-size",
                    maxValue: 245000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.Containership.sizeMsi : VesselCharacteristicInfoMessageBySectorName.Containership.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "c-min-year",
                    minValue: 1980,
                    endHtmlId: "c-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "c-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "c-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.countryOfBuild
                }
            },            
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "c-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "c-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Gear",
                    name: "gear",
                    htmlId: "c-gear",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.Gear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.gear
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Dwt Capacity",
                    name: "dwtCapacity",
                    startHtmlId: "c-min-dwt-capacity",
                    minValue: null,
                    endHtmlId: "c-max-dwt-capacity",
                    maxValue: null,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.dwtCapacity
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Reefer Plugs",
                    name: "reeferPlugs",
                    startHtmlId: "c-min-reefer-plugs",
                    minValue: null,
                    endHtmlId: "c-max-refer-plugs",
                    maxValue: null,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.reeferPlugs
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Homogeneous Intake at 14T",
                    name: "homogenousIntake",
                    startHtmlId: "c-min-homogeneous-intake",
                    minValue: null,
                    endHtmlId: "c-max-homogeneous-intake",
                    maxValue: null,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.homogeneousIntake
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Eco",
                    name: "eco",
                    htmlId: "c-eco",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.Eco,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.eco
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "c-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.scrubberFitted
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Fuel System",
                    name: "fuelSystem",
                    htmlId: "c-fuel-system",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.FuelSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.fuelSystem
                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "c-min-draught",
                    endHtmlId: "c-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.Containership.draught
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }

        ]
    },
    {
        sectorCode: "CH",
        name: "Chemical Tanker",
        htmlId: "chemical-tanker",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.CH.label} (${SizeLabelAndUnitBySectorCode.CH.unit})`,
                    name: "size",
                    startHtmlId: "ch-min-size",
                    minValue: isMSI ? 0 : 300,
                    endHtmlId: "ch-max-size",
                    maxValue: 52000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.sizeMsi : VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "ch-min-year",
                    minValue: 1980,
                    endHtmlId: "ch-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "ch-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.ChemicalTanker.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "ch-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.ChemicalTanker.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.countryOfBuild
                }
            },            
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "ch-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "ch-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.ChemicalTanker.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Tank",
                    name: "tank",
                    htmlId: "ch-tank",
                    options: VesselCharactericsSelectOptionsBySectorName.ChemicalTanker.Tank,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.tank
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "IMO Class and Coating",
                    name: "imoClassAndCoating", 
                    htmlId: "ch-imo-class-coating",
                    options: VesselCharactericsSelectOptionsBySectorName.ChemicalTanker.ImoClassCoating,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.imoClassAndCoating
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "ch-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.Containership.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.scrubberFitted

                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "ch-min-draught",
                    endHtmlId: "ch-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.ChemicalTanker.draught
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }
        ]
    },
    {
        sectorCode: "LNG",
        name: "LNG Carrier",
        htmlId: "lng-carrier",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.LNG.label} (${SizeLabelAndUnitBySectorCode.LNG.unit})`,
                    name: "size",
                    startHtmlId: "lng-min-size",
                    minValue: isMSI ? 0 : 120000,
                    endHtmlId: "lng-max-size",
                    maxValue: 300000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.LngCarrier.sizeMsi : VesselCharacteristicInfoMessageBySectorName.LngCarrier.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "lng-min-year",
                    minValue: 1980,
                    endHtmlId: "lng-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "lng-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.LngCarrier.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "lng-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.LngCarrier.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.countryOfBuild,
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "lng-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "lng-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.LngCarrier.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Propulsion System",
                    name: "propulsionSystem",
                    htmlId: "lng-propulsion-system",
                    options: VesselCharactericsSelectOptionsBySectorName.LngCarrier.PropulsionSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.propulsionSystem
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Cargo Containment",
                    name: "cargoContainment",
                    htmlId: "lng-cargo-containment",
                    options: VesselCharactericsSelectOptionsBySectorName.LngCarrier.CargoContainment,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.cargoContainment
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "lng-min-draught",
                    endHtmlId: "lng-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LngCarrier.draught
                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }
        ]
    },
    {
        sectorCode: "LPG",
        name: "LPG Carrier",
        htmlId: "lpg-carrier",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.LPG.label} (${SizeLabelAndUnitBySectorCode.LPG.unit})`,
                    name: "size",
                    startHtmlId: "lpg-min-size",
                    minValue: isMSI ? 0 : 25000,
                    endHtmlId: "lpg-max-size",
                    maxValue: 350000,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.LpgCarrier.sizeMsi : VesselCharacteristicInfoMessageBySectorName.LpgCarrier.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "lpg-min-year",
                    minValue: 1980,
                    endHtmlId: "lpg-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "lpg-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "lpg-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.countryOfBuild
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "lpg-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "lpg-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.yardTier  
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Tank Type",
                    name: "tank",
                    htmlId: "lpg-tank-type",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.TankType,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.tank
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ammonia Carrier",
                    name: "ammoniaCarrier",
                    htmlId: "lpg-ammonia-carrier",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.AmmoniaCarrier                        
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "lpg-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.ScrubberFitted
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Fuel System",
                    name: "fuelSystem",
                    htmlId: "lpg-fuel-system",
                    options: VesselCharactericsSelectOptionsBySectorName.LpgCarrier.FuelSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.fuelSystem
                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "lpg-min-draught",
                    endHtmlId: "lpg-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.LpgCarrier.draught
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }
        ]
    },
    {
        sectorCode: "PCTC",
        name: "Car/Truck Carrier",
        htmlId: "car-truck-carrier",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.PCTC.label} (${SizeLabelAndUnitBySectorCode.PCTC.unit})`,
                    name: "size",
                    startHtmlId: "pctc-min-size",
                    minValue: isMSI ? 0 : 500,
                    endHtmlId: "pctc-max-size",
                    maxValue: 12500,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.sizeMsi : VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "pctc-min-year",
                    minValue: 1980,
                    endHtmlId: "pctc-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "pctc-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "pctc-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.countryOfBuild
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "pctc-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "pctc-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Hoistable Decks",
                    name: "hoistableDecks",
                    htmlId: "pctc-hoistable-decks",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.HoistableDecks,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.hoistableDecks
                }
            },                
            {
                type: "sectorRangeInput",
                props: {
                    label: "Quarter Ramp Capacity",
                    name: "quarterRampCapacity",
                    startHtmlId: "pctc-min-quarter-ramp-capacity",
                    minValue: 5,
                    endHtmlId: "pctc-max-quarter-ramp-capacity",
                    maxValue: 4000,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.quarterRampCapacity
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "pctc-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.scrubberFitted
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Fuel System",
                    name: "fuelSystem",
                    htmlId: "pctc-fuel-system",
                    options: VesselCharactericsSelectOptionsBySectorName.CarTruckCarrier.FuelSystem,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.fuelSystem
                }
            },           
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "pctc-min-draught",
                    endHtmlId: "pctc-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.CarTruckCarrier.draught
                }
            }, 
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }
        ]
    },
    {
        sectorCode: "MPP",
        name: "Multi-Purpose",
        htmlId: "multi-purpose",
        components: [
            {
                type: "sectorRangeInput",
                props: {
                    label: `${SizeLabelAndUnitBySectorCode.MPP.label} (${SizeLabelAndUnitBySectorCode.MPP.unit})`,
                    name: "size",
                    startHtmlId: "pctc-min-size",
                    minValue: isMSI ? 0 : 7000,
                    endHtmlId: "pctc-max-size",
                    maxValue: 37500,
                    characteristicInfo: isMSI ? VesselCharacteristicInfoMessageBySectorName.MultiPurpose.sizeMsi : VesselCharacteristicInfoMessageBySectorName.MultiPurpose.size
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Year of Delivery",
                    name: "yearOfDelivery",
                    startHtmlId: "mpp-min-year",
                    minValue: 1980,
                    endHtmlId: "mpp-max-year",
                    maxValue: maxYear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.yearOfDelivery
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Ice Class",
                    name: "iceClass",
                    htmlId: "mpp-ice-class",
                    options: VesselCharactericsSelectOptionsBySectorName.MultiPurpose.IceClass,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.iceClass
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Country of Build",
                    name: "countryOfBuild",
                    htmlId: "mpp-country-of-build",
                    options: VesselCharactericsSelectOptionsBySectorName.MultiPurpose.CountryOfBuild,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.countryOfBuild
                }
            },            
            {
                type: "sectorSelect",
                props: {
                    label: "Flag State",
                    name: "flag",
                    htmlId: "mpp-flag",
                    options: [],
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.flag
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Yard Tier",
                    name: "yardTier",
                    htmlId: "mpp-yard-tier",
                    options: VesselCharactericsSelectOptionsBySectorName.MultiPurpose.YardTier,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.yardTier
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Gear",
                    name: "gear",
                    htmlId: "mpp-gear",
                    options: VesselCharactericsSelectOptionsBySectorName.MultiPurpose.Gear,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.gear
                }
            },
            {
                type: "sectorSelect",
                props: {
                    label: "Scrubber Fitted",
                    name: "scrubberFitted",
                    htmlId: "mpp-scrubber-fitted",
                    options: VesselCharactericsSelectOptionsBySectorName.MultiPurpose.ScrubberFitted,
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.scrubberFitted
                }
            },            
            {
                type: "sectorRangeInput",
                props: {
                    label: "Draught (m)",
                    name: "draught",
                    startHtmlId: "mpp-min-draught",
                    endHtmlId: "mpp-max-draught",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.MultiPurpose.draught
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Beam (m)",
                    name: "breadth",
                    startHtmlId: "d-min-breadth",
                    endHtmlId: "d-max-breadth",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.breadth
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Length Overall (m)",
                    name: "lengthOverallLoa",
                    startHtmlId: "d-min-lengthOverallLoa",
                    endHtmlId: "d-max-lengthOverallLoa",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.lengthOverallLoa
                }
            },
            {
                type: "sectorRangeInput",
                props: {
                    label: "Gross Tonnage",
                    name: "grossTonnage",
                    startHtmlId: "d-min-grossTonnage",
                    endHtmlId: "d-max-grossTonnage",
                    characteristicInfo: VesselCharacteristicInfoMessageBySectorName.DryBulk.grossTonnage
                }
            }
        ]
    }
];
